import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { IStoreState } from '@core/store/store.state';
import { AuthLoginAction } from '@modules/users/store/user.actions';
import { LOGSEVERITY, LOGTYPE } from '../../app.costants';
import { ErrorService } from '@services/error.service';
import { WatchdogService } from '@services/watchdog.service';
import { AuthenticationService } from '@services/authentication.service';
import {createLoginForm} from "@modules/login/login.form";
import {ErrorMapping} from "@core/constants";
import {NewTokenAction} from "@core/store/token/token.actions";
import {SearchCustomersService} from "@modules/search-customers/search-customers.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public formGroup: FormGroup;
  public errorMessage = ErrorMapping;
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public password = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthenticationService,
    private router: Router,
    private store: Store<IStoreState>,
    private snackbar: MatSnackBar,
    private watchdog: WatchdogService,
    private errorService: ErrorService,
    private searchCustomersService: SearchCustomersService
  ) {
    this.formGroup = createLoginForm();
  }

  ngOnInit(): void { }

  showPassword(){
    this.password = !this.password;
  }

  login() {
    this.isLoading$.next(true);
      this.auth
        .login(this.formGroup.value.email, this.formGroup.value.password)
        .subscribe({
          next: response => {
            this.isLoading$.next(false);
            switch (response?.status?.codice){
              case '401': {
                const errorMessage = "La password inserita non è corretta.";
                this.errorService.setError(errorMessage);
                break;
              }
              case '015': {
                const errorMessage = "L'utente non ha ancora effettuato il cambio password.";
                this.errorService.setError(errorMessage);
                this.searchCustomersService.setIrenYouEmail(this.formGroup.controls.email.value);
                this.store.dispatch(NewTokenAction({token: response.data.id_token}));
                this.router.navigateByUrl( '/reset-password');
                break;
              }
              case '0055': {
                const errorMessage = "La password è scaduta.";
                this.errorService.setError(errorMessage);
                this.searchCustomersService.setIrenYouEmail(this.formGroup.controls.email.value);
                this.store.dispatch(NewTokenAction({token: response.data.id_token}));
                this.router.navigateByUrl( '/expired-password');
                break;
              }
              case '016': {
                const expiredDate = response.status.descrizione.substring(response.status.descrizione.indexOf(":") + 2);
                const errorMessage = `Utenza bloccata temporaneamente, riprovare più tardi. /\n Il tuo account verrà sbloccato il: ${new Date(expiredDate).getDate()}/${new Date(expiredDate).getMonth()+1}/${new Date(expiredDate).getFullYear()}`;
                this.errorService.setError(errorMessage);
                break;
              }
              case '0428': {
                const errorMessage = "Utente non autorizzato ad accedere alla Dashboard.";
                this.errorService.setError(errorMessage);
                break;
              }
              default: {
                this.store.dispatch(NewTokenAction({token: response.data.id_token}));

                this.auth.checkUser(response.data.username).subscribe({
                  next: user => {
                    this.store.dispatch(AuthLoginAction({ user }));
                    this.watchdog.writeWatchdog({
                      type: LOGTYPE.INFO,
                      severity: LOGSEVERITY.NONE,
                      message: "L'utente ha effettuato il login",
                    });
                    this.router.navigateByUrl('/private-area');
                  }
                })
              }
            }
          },
          error: err => {
            this.isLoading$.next(false);
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.HIGHT,
              message: `L'utente ${this.formGroup.value.email} ha fallito l'accesso alla dashboard`,
            });
            this.errorService.setError('Errore di comunicazione con il server.');
          }
        })
    }
}
